module.exports = "<div class=\"procurement-schedules\"><ui-view></ui-view></div>";